import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DEFAULT_SCORE_BASE, SCORING_BASE_OPTIONS, ScoreBaseOption } from 'app/shared/constant/scoreBase.constant';

@Component({
  selector: 'cygov-score-base',
  templateUrl: './score-base.component.html',
  styleUrls: ['./score-base.component.scss'],
  standalone: false,
})
export class ScoreBaseComponent implements OnInit {
  @Input() set currentScoringBase(value: number | null | undefined) {
    this._currentScoringBase = value ?? DEFAULT_SCORE_BASE;
    this.updateCheckedState();
  }

  get currentScoringBase(): number {
    return this._currentScoringBase;
  }

  private _currentScoringBase: number = DEFAULT_SCORE_BASE;
  @Output() scoringBaseChange = new EventEmitter<number>();

  scoringBaseOptions: ScoreBaseOption[] = JSON.parse(JSON.stringify(SCORING_BASE_OPTIONS));

  constructor() {}

  ngOnInit() {
    // Ensure default is set if input was not provided
    if (this._currentScoringBase === null || this._currentScoringBase === undefined) {
      this._currentScoringBase = DEFAULT_SCORE_BASE;
    }
    this.updateCheckedState();
  }

  scoringBaseChangeHandler(event: any, option: ScoreBaseOption): void {
    event.stopPropagation();
    this._currentScoringBase = option.value;
    this.updateCheckedState();
    this.scoringBaseChange.emit(this._currentScoringBase);
  }

  private updateCheckedState(): void {
    this.scoringBaseOptions.forEach(opt => (opt.checked = opt.value === this._currentScoringBase));
  }
}
